import { ReactElement } from 'react';

import { Dropdown } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';

type OpenEntryEditModalDropdownItemProps = {
   onClick: VoidFunction;
   disabled: boolean;
};

export const OpenEntryEditModalDropdownItem = (props: OpenEntryEditModalDropdownItemProps): ReactElement => {
   return (
      <Dropdown.Item
         testId={'openEntryEditModal'}
         onClick={(hide) => {
            props.onClick();
            hide();
         }}
         disabled={props.disabled}
      >
         <Translate>{translationKeys.edit}</Translate>
      </Dropdown.Item>
   );
};
